import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import type { CarConfigStateType } from "../store";

import type { MotorizationType } from "../../../../shared-logic/types/Motorization";

export type CarConfigMotorizationType = {
    initialized: boolean;
    motorization: MotorizationType[];
};

export const initialStateCarConfigMotorization: CarConfigMotorizationType = {
    initialized: false,
    motorization: [],
};

export type CarConfigMotorizationActionTypes = ReturnType<typeof initCarConfigMotorization>;

export const CarConfigMotorizationSlice = createSlice({
    name: "carConfigMotorization",
    initialState: initialStateCarConfigMotorization,
    reducers: {
        initCarConfigMotorization(state, action: PayloadAction<Pick<CarConfigMotorizationType, "motorization">>) {
            return {
                ...state,
                ...action.payload,
                initialized: true,
            };
        },
    },
});

export const { initCarConfigMotorization } = CarConfigMotorizationSlice.actions;

export const selectMotorization = (state: CarConfigStateType): MotorizationType[] =>
    state.carConfigMotorization.motorization;
